const ErrorFile = () => {
  return (
    <div style={{ margin: "30px 20px 40px 20px" }}>
      <h4>
        We're sorry. There seems to be an issue with your student list file.
        Please contact us.
      </h4>
    </div>
  );
};

export default ErrorFile;
